import PasswordRecovery from '../components/PasswordRecovery'
export default function ResetPassword() { return <PasswordRecovery reset /> }
